import type { UserDistributionSetting } from "@app/common/types";

export const DEFAULT_MEETING_RECAP_EMAIL_DISTRIBUTION: UserDistributionSetting =
  {
    method: "email",
    category: "meeting_report",
    isEnabled: true,
    frequency: "instant",
    sendTo: "participants_with_access",
  };

export const DEFAULT_PRE_READ_EMAIL_DISTRIBUTION: UserDistributionSetting = {
  method: "email",
  category: "meeting_pre_read",
  isEnabled: true,
  frequency: "instant",
  sendTo: "participants_with_access",
};
